import { ProcessForm } from "./_ProcessForm";

export function ProcessCreate() {
  return <ProcessForm action="create" />;
}

export default ProcessCreate;
